import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "counter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, "りんご１個:" + _toDisplayString(_ctx.appleObj.price) + "円", 1),
    _createElementVNode("label", null, [
      _createTextVNode(" 購入したい" + _toDisplayString(_ctx.appleObj.name) + "の数: ", 1),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputNum) = $event)),
        type: "text"
      }, null, 512), [
        [_vModelText, _ctx.inputNum]
      ])
    ]),
    _createElementVNode("p", null, "りんご" + _toDisplayString(_ctx.inputNum) + "つの合計金額は" + _toDisplayString(_ctx.calcSum) + "円です。", 1)
  ]))
}